import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../global/components/spinner/spinner.component';
import { WorkOrderStatusIndicatorComponent } from '../../components/work-order-status-indicator/work-order-status-indicator.component';
import { DisclaimerComponent } from '../../components/disclaimer/disclaimer.component';
import { CallAssistanceBtnComponent } from '../../components/call-assistance-btn/call-assistance-btn.component';
import { AvatarElementComponent } from '../../../global/components/avatar-element/avatar-element.component';
import { CaptainBannerComponent } from '../../components/captain-banner/captain-banner.component';
import { TrackingMapComponent } from '../../components/tracking-map/tracking-map.component';
import { UpdateLocationComponent } from '../../components/update-location/update-location.component';
import { ToastModule } from 'primeng/toast';
import {
  CAPTAIN_PIN,
  MEMBER_PIN,
  TYC_BOAT_HERO_IMG,
  Status
} from '../../../../helpers/constants';
import { Observable, Subject, takeUntil } from 'rxjs';
import { MarkerService } from '../../../../services/marker.service';
import { determineWorkOrderStatus } from '../../../../helpers/helpers';
import { animate, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { NoJobIdPageComponent } from "../../../no-job-id/view/no-job-id-page/no-job-id-page.component";

@Component({
  selector: 'app-tyc-page',
  standalone: true,
  imports: [
    CommonModule,
    ToastModule,
    SpinnerComponent,
    WorkOrderStatusIndicatorComponent,
    DisclaimerComponent,
    CallAssistanceBtnComponent,
    AvatarElementComponent,
    CaptainBannerComponent,
    TrackingMapComponent,
    UpdateLocationComponent,
    NoJobIdPageComponent
],
  providers: [MessageService],
  templateUrl: './tyc-page.component.html',
  styleUrl: './tyc-page.component.css',
  animations: [
    trigger('fadeAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('300ms ease-out', style({ opacity: 0 }))]),
    ]),
  ],
})
export class TycPageComponent implements OnInit, OnDestroy {
  jobId!: string;

  $jobStatus!: Observable<any>;
  $spinner!: Observable<any>;
  $toastMessage!: Observable<string>;

  permissionStatus: PermissionStatus | null = null;
  tycBoatHeroImg: string = TYC_BOAT_HERO_IMG;
  memberPin: string = MEMBER_PIN;
  captainPin: string = CAPTAIN_PIN;
  Status = Status

  private ngUnsubscribe = new Subject<void>();

  constructor(
    private markerService: MarkerService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) {
    this.$jobStatus = this.markerService.$jobStatus;
    this.$spinner = this.markerService.$spinner;
    this.$toastMessage = this.markerService.$toastMessage;
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    // Clean up the event listener
    if (this.permissionStatus) {
      this.permissionStatus.removeEventListener(
        'change',
        this.permissionChange
      );
    }
  }
  ngOnInit(): void {
    //Add Permission Status Event Listener
    if (navigator.permissions) {
      navigator.permissions.query({ name: 'geolocation' }).then((status) => {
        this.permissionStatus = status;
        this.permissionStatus.addEventListener('change', this.permissionChange);
      });
    }

    this.jobId =
      this.route.snapshot.paramMap.get('jobId') || ''
    this.markerService.nextJobId(this.jobId);

    //Setup Toast Messages
    this.$toastMessage.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (toastMsg) => {
        if (toastMsg != '') {
          this.messageService.add({
            severity: 'warn',
            summary: 'Location',
            detail: toastMsg,
            life: 3000,
            key: 'tc',
          });
        }
      },
      error: (e) =>
        console.error(
          '[TYC]: Error emitting $toastMessage Observable in OnInit',
          e
        ),
    });

    //PUSH Data into BehaviorSubjects
    this.markerService
      .getJobLocation(this.jobId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (jobData) => {
          console.log('[TYC PAGE]: ', jobData);

          const jobStatus = determineWorkOrderStatus(jobData);
          this.markerService.updateJobStatus(jobStatus);
          this.markerService.updateCaptainLocation(jobData);
        },
        error: (e) =>
          console.error('[TYC PAGE]: Error Trying To Get Job Locations', e),
      });

    this.markerService.getMemberLocation();
  }

  private permissionChange = (event: Event) => {
    console.log(
      '[TYC PAGE]: Permission Status Changed To: ',
      this.permissionStatus?.state
    );
    const newState = (event.target as PermissionStatus).state;
    this.handlePermissionChange(newState);
  };

  handlePermissionChange(newState: PermissionState) {
    console.log('[TYC PAGE]: Handling Location State Change Of: ', newState);
    switch (newState) {
      case 'granted':
        this.markerService.updateSpinnerSubject(true);
        console.log('[TYC PAGE]: Permission Granted, Getting Member Location');
        this.markerService.updateMemberLocationFromGeoLocation();
        break;
      case 'denied':
        console.log('[TYC PAGE]: Persmission Denied');
        this.markerService.updateMemberLocation({
          lat: 0,
          lon: 0,
        });
        break;
      default:
        console.log(
          '[TYC PAGE]: Unknown Value in handlePermissionChange',
          newState
        );
        break;
    }
  }
}
